import { axios } from '@/utils/request'


const api = {
  orderDetail: '/adminapi/shopOrder/orderdetail',
  orderConfirm: '/adminapi/shopOrder/orderConfirm',
  orderUse: '/adminapi/shopOrder/orderUse',
}
export default api
export function getOrderDetail(parameter) {
  return axios({
    url: api.orderDetail,
    method: 'get',
    params: parameter
  })
}
export function orderConfirm(parameter) {
  return axios({
    url: api.orderConfirm,
    method: 'post',
    data: parameter
  })
}
export function orderUse(parameter) {
  return axios({
    url: api.orderUse,
    method: 'post',
    data: parameter
  })
}